import { render, staticRenderFns } from "./VerifyAadharOtp.vue?vue&type=template&id=79ccddbd"
import script from "./VerifyAadharOtp.vue?vue&type=script&lang=js"
export * from "./VerifyAadharOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports